import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/leads/RoleHeader'
import YoneticiGruplari from '../components/leads/YoneticiGruplari'
import Footer from '../components/shared/Footer'

const UpdateRole = () => {
    return (
        <>
            <PageHeader>
            
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <YoneticiGruplari />
                </div>
            </div>
            
        </>
    )
}

export default UpdateRole